import { createIcon } from '../utils';

export const BatteryIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.33337 12L9.00004 8H5.00004L7.66671 4M14.6667 8.66667V7.33333M9.33337 12H9.46671C10.5868 12 11.1469 12 11.5747 11.782C11.951 11.5903 12.257 11.2843 12.4487 10.908C12.6667 10.4802 12.6667 9.92011 12.6667 8.8V6.66667C12.6667 6.04669 12.6667 5.7367 12.5986 5.48236C12.4136 4.79218 11.8745 4.25308 11.1843 4.06815C10.93 4 10.62 4 10 4M4.66671 4H4.53337C3.41327 4 2.85322 4 2.42539 4.21799C2.04907 4.40973 1.74311 4.71569 1.55136 5.09202C1.33337 5.51984 1.33337 6.0799 1.33337 7.2V9.33333C1.33337 9.95331 1.33337 10.2633 1.40152 10.5176C1.58646 11.2078 2.12555 11.7469 2.81574 11.9319C3.07007 12 3.38006 12 4.00004 12"
        stroke="currentColor"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'BatteryIcon',
  },
);

export const BatteryLowIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.22214 10L8.33325 8H5.66659L6.7777 6M14.6666 8.66667V7.33333M4.53325 12H9.46658C10.5867 12 11.1467 12 11.5746 11.782C11.9509 11.5903 12.2569 11.2843 12.4486 10.908C12.6666 10.4802 12.6666 9.92011 12.6666 8.8V7.2C12.6666 6.0799 12.6666 5.51984 12.4486 5.09202C12.2569 4.71569 11.9509 4.40973 11.5746 4.21799C11.1467 4 10.5867 4 9.46659 4H4.53325C3.41315 4 2.85309 4 2.42527 4.21799C2.04895 4.40973 1.74299 4.71569 1.55124 5.09202C1.33325 5.51984 1.33325 6.0799 1.33325 7.2V8.8C1.33325 9.92011 1.33325 10.4802 1.55124 10.908C1.74299 11.2843 2.04895 11.5903 2.42527 11.782C2.85309 12 3.41315 12 4.53325 12Z"
        stroke="#EF4444"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'BatteryLowIcon',
  },
);

export const BatteryMidIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.69995 6.36589V9.03255M6.36662 6.36589V9.03255M14.0333 8.36589V7.03255M3.89995 11.69922H8.83328C9.95339 11.69922 10.5134 11.69922 10.9413 11.48123C11.3176 11.28949 11.6236 10.98352 11.8153 10.6072C12.0333 10.17938 12.0333 9.61932 12.0333 8.49922V6.89922C12.0333 5.77911 12.0333 5.21906 11.8153 4.79124C11.6236 4.41491 11.3176 4.10895 10.9413 3.917206C10.5134 3.699219 9.95339 3.699219 8.83328 3.699219H3.89995C2.77985 3.699219 2.21979 3.699219 1.79197 3.917206C1.41565 4.10895 1.10968 4.41491 0.917938 4.79124C0.699951 5.21906 0.699951 5.77911 0.699951 6.89922V8.49922C0.699951 9.61932 0.699951 10.17938 0.917938 10.6072C1.10968 10.98352 1.41565 11.28949 1.79197 11.48123C2.21979 11.69922 2.77985 11.69922 3.89995 11.69922Z"
        stroke="#FBBF24"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'BatteryMidIcon',
  },
);

export const BatteryHighIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.33325 6.66667V9.33333M6.99992 6.66667V9.33333M9.66658 6.66667V9.33333M14.6666 8.66667V7.33333M4.53325 12H9.46658C10.5867 12 11.1467 12 11.5746 11.782C11.9509 11.5903 12.2569 11.2843 12.4486 10.908C12.6666 10.4802 12.6666 9.92011 12.6666 8.8V7.2C12.6666 6.0799 12.6666 5.51984 12.4486 5.09202C12.2569 4.71569 11.9509 4.40973 11.5746 4.21799C11.1467 4 10.5867 4 9.46659 4H4.53325C3.41315 4 2.85309 4 2.42527 4.21799C2.04895 4.40973 1.74299 4.71569 1.55124 5.09202C1.33325 5.51984 1.33325 6.0799 1.33325 7.2V8.8C1.33325 9.92011 1.33325 10.4802 1.55124 10.908C1.74299 11.2843 2.04895 11.5903 2.42527 11.782C2.85309 12 3.41315 12 4.53325 12Z"
        stroke="#16A34A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'BatteryHighIcon',
  },
);
